<div *ngIf="!cookiesAccepted" [ngStyle]="{'display': cookiesAccepted ? 'none' : 'block'}" class="cookie-banner">
    <div mat-dialog-title class="cust-modal-title">
      <h2 class="m-0 modal-header-text" style="font-weight: 600;">We use cookies</h2>
      <button (click)="closeBanner()" mat-icon-button  id="matDialogClose">
    <mat-icon>close</mat-icon>
    </button>
    </div>
    <p>Cookies help us deliver the best experience on our website. By using our website, you agree to the use of cookies. To know more, please read our <a style="color:#f20c49" href="https://lookzup.com/cookie-policy" target="_blank">cookie policy</a></p>
    <button style="    width: 100%;
    background: #fff;
    border: 2px solid #000;
    margin-top: 20px;
    height: 40px;font-weight:600" (click)="acceptCookies()">ACCEPT</button>
  </div>
  